module.exports = __webpack_public_path__ + "static/img/legend_xa_english.1c0ce65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xa_english.png
// module id = K1wN
// module chunks = 94